import { ColorEnum } from '@/constants/color'
import { useScreenLayout } from '@/hooks/screen'
import { FC, ReactNode } from 'react'
import { StyleSheet, View } from 'react-native'
import { SvgProps } from 'react-native-svg'

interface InfoRowProps {
    Icon: FC<SvgProps>
    content: ReactNode
}

const InfoRow: FC<InfoRowProps> = ({ Icon, content }) => {
    const screenLayout = useScreenLayout()

    return (
        <View style={[styles.container, screenLayout === 'compact' && styles.containerCompact]}>
            <Icon fill={ColorEnum.BRICK_600} width={20} height={20} />
            <View style={styles.content}>{content}</View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
    },
    containerCompact: {
        gap: 8,
    },
    content: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
})

export default InfoRow
